import React, { useEffect } from 'react'
import NavbarContainer from '../Components/NavbarContainer/NavbarContainer'
import Header from '../Components/Header/Header'
import FinalExam from '../Components/FinalExam/FinalExam'
import TrainingCourses from '../Components/TrainingCourses/TrainingCourses'
import { fetchCourses } from '../hook/courses';
import { useDispatch, useSelector } from 'react-redux'
import { fetchFinalExam } from '../hook/finalExam'
import { Container } from 'react-bootstrap'

function HomeDashboard() {
  const { auth } = useSelector((state) => state);
  console.log(auth);

  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(fetchCourses());
    dispatch(fetchFinalExam());



  }, [dispatch])
  return (
    <div >
      <NavbarContainer />
      <Header />
      <Container>
        <TrainingCourses />

      </Container>
      <FinalExam />
    </div>
  )
}

export default HomeDashboard